import React from 'react';
import Loading from '../../../../components/loading/Loading';
import CustomButton from '../../../../components/buttons/CustomButton';
import ActionRow from './ActionRow';
import { ACTIONS_DAYS } from '../hooks/useRecoveryData';
import { formatMoney } from '../utils';
import styles from '../Recovery.module.css';

const STATS = [
  { key: 'contacts', label: 'Contatos' },
  { key: 'sent', label: 'Enviados' },
  { key: 'failed', label: 'Falhas' },
  { key: 'booked', label: 'Retornos' },
  { key: 'attended', label: 'Realizados' },
  { key: 'attendedValue', label: 'Valor realizado', money: true },
];

/**
 * Card "Resultado": números dos últimos 30 dias, a regra de atribuição
 * declarada e a lista de ações com status real.
 */
function ResultsPanel({ actions, onRetry }) {
  const { status, summary, attributionRule, list, error } = actions;

  function renderBody() {
    if (status === 'loading') return <div className={styles.loadingRow}><Loading /></div>;
    if (status === 'error') {
      return (
        <div className={styles.error}>
          <span>{error}</span>
          <CustomButton variant="outlined" style="primary" label="Tentar de novo" onClick={onRetry} />
        </div>
      );
    }
    return (
      <>
        <div className={styles.summaryGrid}>
          {STATS.map((stat) => (
            <div key={stat.key} className={styles.stat}>
              <span className={styles.statValue}>
                {stat.money ? formatMoney(summary?.[stat.key] || 0) : (summary?.[stat.key] || 0)}
              </span>
              <span className={styles.statLabel}>{stat.label}</span>
            </div>
          ))}
        </div>
        {list.length === 0 ? (
          <div className={styles.empty}>Nenhum contato nos últimos {ACTIONS_DAYS} dias.</div>
        ) : (
          <div className={styles.actionList}>
            {list.map((action) => <ActionRow key={action.id} action={action} />)}
          </div>
        )}
      </>
    );
  }

  return (
    <section className={styles.card} aria-label="Resultado">
      <header className={styles.cardHeader}>
        <div>
          <h2 className={styles.cardTitle}>Resultado dos últimos {ACTIONS_DAYS} dias</h2>
          <p className={styles.cardSubtitle}>
            {attributionRule || 'Conta como retorno o agendamento criado em até 14 dias após o contato.'}
          </p>
        </div>
      </header>
      <div className={styles.cardBody}>{renderBody()}</div>
    </section>
  );
}

export default ResultsPanel;
